import styled from "styled-components";

export const Text = styled.p`
  display: flex;
  justify-content: center;
  margin-top: 50px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fafafa;
  margin-bottom: 48px;
`;

export const TBody = styled.tbody``;

export const Row = styled.tr`
  border-bottom: 1px solid #ddd;
`;

export const Cell = styled.td`
  padding: 8px 12px;

  &:first-child {
    font-weight: bold;
    width: 180px;
    background: #f0f0f0;
  }
`;

export const NoData = styled.div`
  padding: 20px;
  text-align: center;
  color: #555;
  font-size: 1.05rem;
  background: #f8f8f8;
  border: 1px dashed #ccc;
  border-radius: 6px;
  font-style: italic;
`;
